export default __webpack_public_path__ + "static/media/bg-shine.346efe7b.png";